/* =============================================================================
*/

export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: {},
  staticActions: {},
  schema: {}
};
